import { render } from "./KYCView.vue?vue&type=template&id=905de07c"
import script from "./KYCView.vue?vue&type=script&lang=js"
export * from "./KYCView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__